import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import PuffLoader from "react-spinners/PuffLoader";
import DecorationBackground from "./DecorationBackground";
import { ToastContainer, toast } from "react-toastify";
import { useForm, SubmitHandler } from "react-hook-form";
import {
  ButtonEntry,
  Container,
  CreateAccountContent,
  Heading,
  InputBase,
  LeftWrapper,
  MainContainer,
  RightWrapper,
  Title,
  Text,
  WrapperRadio,
  InputRadio,
  OptionLabel,
  WrapperRadioII,
  ButtonCreateNewAccount,
  Label,
  InputCheckbox,
  TextInfo,
  ButtonLoginMobile,
  Select,
  RadioBox,
  SpaceFinal,
  TextDefault
} from "./styles";
import IconSvg from "../../editor/components/IconSvg";
import { yupResolver } from "@hookform/resolvers/yup";
import LogoUXDOC from "../assets/logo-white-uxdoc.svg";
import api from "../../../services/api";
import { LoadingFlex } from "../../login/pages/Login/styles";
import { useAuth } from "../../../hooks/auth";
import { lowerCase } from "lodash";
import StyledMaskInput from "../components/StyledMaskInput";
import { useToolbarEditor } from "../../editor/hooks/toolbarEditor";

interface SubmitProps {
  first_name: string;
  last_name?: string;
  email: string;
  password: string;
  where_do_you_work: string;
  how_did_you_meet_us: string;
  phone: string;
  register?: string;
}

interface RegisterProps {
  isPayment?: boolean;
  setIsPayment?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RegisterScreen: React.FC<RegisterProps> = ({
  isPayment,
  setIsPayment
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showErrorRegister, setShowErrorRegister] = useState<{
    error: boolean;
    type: "cpf" | "cnpj";
  }>({
    error: true,
    type: "cpf"
  });

  const { setBlockCommandKeyboard, forceBlockKey, setForceBlockKey } =
    useToolbarEditor();

  useEffect(() => {
    setForceBlockKey(true);
  }, []);

  const [showErrorPhone, setShowErrorPhone] = useState(true);

  const [typeRegisterCustomer, setTypeRegisterCustomer] = useState<
    "cpf" | "cnpj"
  >("cpf");
  const { createdAccount, setCreatedAccount, signIn } = useAuth();
  const [hasSubmited, setHasSubmited] = useState(false);
  const [checkedLGPD, setCheckedLGPD] = useState(false);
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const schema = yup.object({
    first_name: yup.string().required("Nome obrigatório"),
    last_name: yup.string().required("Sobrenome obrigatório"),
    email: yup.string().email("Email inválido").required(),
    // phone: yup
    //   .string()
    //   .required(`Telefone inválido`)
    //   .matches(phoneRegExp, `Telefone inválido`),
    password: yup.string().min(6).required(`Senha necessária`),
    where_do_you_work: yup.string().required(`Onde trabalha necessário`),
    how_did_you_meet_us: yup.string().required(`Como nos conheceu necessário`)
  });

  const [customerRegister, setCustomerRegister] = useState("");
  const [customerRegisterPhone, setCustomerRegisterPhone] = useState("");

  const handleRegisterCustomer = useCallback(
    (value, mask) => {
      setCustomerRegister(mask._unmaskedValue);
    },
    [customerRegister]
  );

  const handleRegisterPhone = useCallback(
    (value, mask) => {
      setCustomerRegisterPhone(mask._unmaskedValue);
    },
    [customerRegister]
  );

  useEffect(() => {
    const lengthOfRegisterInput = customerRegister.length;

    if (typeRegisterCustomer === "cpf") {
      if (lengthOfRegisterInput === 11) {
        setShowErrorRegister(state => {
          return {
            ...state,
            error: false,
            type: "cpf"
          };
        });
      } else {
        setShowErrorRegister(state => {
          return {
            ...state,
            error: true,
            type: "cpf"
          };
        });
      }
    }

    if (typeRegisterCustomer === "cnpj") {
      if (lengthOfRegisterInput === 14) {
        setShowErrorRegister(state => {
          return {
            ...state,
            error: false,
            type: "cnpj"
          };
        });
      } else {
        setShowErrorRegister(state => {
          return {
            ...state,
            error: true,
            type: "cnpj"
          };
        });
      }
    }
  }, [customerRegister, typeRegisterCustomer]);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SubmitProps>({
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if (
      errors.email ||
      errors.first_name ||
      errors.last_name ||
      errors.how_did_you_meet_us ||
      errors.password ||
      errors.phone ||
      errors.where_do_you_work
    ) {
      setHasSubmited(true);
    }
  }, [errors]);

  useEffect(() => {
    const lengthPhoneNumber = customerRegisterPhone.length;
    if (lengthPhoneNumber === 11) {
      setShowErrorPhone(false);
    } else {
      setShowErrorPhone(true);
    }
  }, [customerRegisterPhone]);

  const onSubmit = async (data: SubmitProps) => {
    if (!checkedLGPD) {
      toast.warn("Por favor aceite aos termos de uso");
    } else {
      if (showErrorRegister.error || showErrorPhone) {
        setHasSubmited(true);
      } else {
        setHasSubmited(false);
        setIsPayment(true);
        try {
          setLoading(true);
          const {
            email,
            first_name,
            last_name,
            phone,
            where_do_you_work,
            how_did_you_meet_us,
            password,
            register
          } = data;
          let newFirstName = first_name.split(" ");
          let newLastName = last_name.split(" ");
          for (let i = 0; i < newFirstName.length; i++) {
            newFirstName[i] =
              newFirstName[i].charAt(0).toUpperCase() +
              newFirstName[i].slice(1);
          }
          for (let i = 0; i < newLastName.length; i++) {
            newLastName[i] =
              newLastName[i].charAt(0).toUpperCase() + newLastName[i].slice(1);
          }
          let finalFirstName = newFirstName.join(" ");
          let finalLastName = newLastName.join(" ");

          let objectForApi = {
            first_name: finalFirstName.trim(),
            last_name: finalLastName.trim(),
            email: email.toLowerCase().trim(),
            password: password,
            phone: customerRegisterPhone,
            user_type: "collaborator",
            where_do_you_work: where_do_you_work,
            how_did_you_meet_us: how_did_you_meet_us,
            document: customerRegister,
            is_individual:
              typeRegisterCustomer === "cpf"
                ? true
                : typeRegisterCustomer === "cnpj" && false
          };
          const responseCreatedUser = await api.post("users", objectForApi);
          console.log(responseCreatedUser, "message error");
          if (responseCreatedUser.status === 200) {
            setLoading(false);
            toast.success("Parabéns! Conta criada com sucesso.");
            await signIn(email, password);
            navigate("/");
          }

          setLoading(false);
        } catch (err) {
          console.log(err.response.data, "error");
          if (
            err.response.data.message === "Invalid CPF." ||
            err.response.data.message === "Invalid CNPJ."
          ) {
            toast.error("CPF ou CNPJ inválido!");
          } else if (
            err.response.data.message === "Email address alredy used"
          ) {
            toast.error("Email em uso!");
          } else {
            toast.error(
              "Ops! Algo deu errado, verifique os dados e tente novamente."
            );
          }
          setLoading(false);
        }
      }
    }
  };

  return (
    <Container>
      <ToastContainer />
      <LeftWrapper>
        <DecorationBackground />
        <MainContainer>
          <IconSvg
            className="logo-uxdoc-register"
            src={LogoUXDOC}
            description=""
          />
          <Heading>Bem vindo!</Heading>

          <ButtonEntry onClick={() => navigate("/")}>
            Já tem conta? Faça o login
          </ButtonEntry>
        </MainContainer>
      </LeftWrapper>
      <RightWrapper>
        <CreateAccountContent onSubmit={handleSubmit(onSubmit)}>
          <Title>Criar conta</Title>
          <TextInfo>
            Comece a transformar seus documentos! Preencha os dados para criar
            sua conta UX DOC
          </TextInfo>
          <InputBase
            style={{ marginTop: "-2rem", textTransform: "capitalize" }}
            placeholder="Nome*"
            {...register("first_name")}
          />
          {errors.first_name?.message && (
            <p className="error-validation">{errors.first_name?.message}</p>
          )}
          <InputBase
            style={{ marginTop: "1.5rem", textTransform: "capitalize" }}
            placeholder="Sobrenome*"
            {...register("last_name")}
          />
          {errors.last_name?.message && (
            <p className="error-validation">{errors.last_name?.message}</p>
          )}
          <InputBase
            style={{ marginTop: "1.5rem", textTransform: "lowercase" }}
            placeholder="Email*"
            {...register("email")}
          />
          {errors.email?.message && (
            <p className="error-validation">{errors.email?.message}</p>
          )}

          <StyledMaskInput
            style={{ marginTop: "1.5rem" }}
            placeholder="Celular*"
            mask={"(00) 00000-0000"}
            onAccept={(value, mask) => handleRegisterPhone(value, mask)}
            // {...register("phone")}
          />
          {hasSubmited && showErrorPhone && (
            <p className="error-validation">Celular inválido</p>
          )}
          <InputBase
            style={{ marginTop: "1.5rem" }}
            placeholder="Senha*"
            type="password"
            {...register("password")}
          />
          {errors.password?.message && (
            <p className="error-validation">{errors.password?.message}</p>
          )}

          <RadioBox>
            <InputRadio
              type="radio"
              name="cpf"
              checked={typeRegisterCustomer === "cpf" ? true : false}
              onChange={event => setTypeRegisterCustomer("cpf")}
            />
            <span>CPF</span>

            <InputRadio
              type="radio"
              value={"cnpj"}
              onChange={event => setTypeRegisterCustomer("cnpj")}
              checked={typeRegisterCustomer === "cnpj" ? true : false}
            />
            <span>CNPJ</span>
          </RadioBox>

          <StyledMaskInput
            style={{ marginTop: "1.5rem" }}
            mask={
              typeRegisterCustomer === "cpf"
                ? "000.000.000-00"
                : typeRegisterCustomer === "cnpj" && "00.000.000/0000-00"
            }
            placeholder={
              typeRegisterCustomer === "cpf"
                ? "CPF*"
                : typeRegisterCustomer === "cnpj" && "CNPJ*"
            }
            onAccept={(value, mask) => handleRegisterCustomer(value, mask)}
            {...register("register")}
          />

          {hasSubmited && showErrorRegister.error && (
            <p className="error-validation">{`${
              showErrorRegister.type.charAt(0).toUpperCase() +
              showErrorRegister.type.slice(1)
            } inválido`}</p>
          )}

          <TextDefault>Onde você atua?*</TextDefault>
          <Select {...register("where_do_you_work")}>
            <option value="">-- Selecione --</option>
            <option value="Escritório de advocacia pequeno">
              Escritório de advocacia pequeno
            </option>
            <option value="Escritório de advocacia grande">
              Escritório de advocacia grande
            </option>
            <option value="Departamento jurídico de empresa">
              Departamento jurídico de empresa
            </option>
            <option value="Sou autônomo (a)">Sou autônomo (a)</option>
            <option value="Sou estudante de Direito">
              Sou estudante de Direito
            </option>
            <option value="Não tenho formação na área jurídica">
              Não tenho formação na área jurídica
            </option>
          </Select>
          {errors.where_do_you_work?.message && (
            <p className="error-validation">Campo obrigatório</p>
          )}
          <TextDefault>Como nos conheceu?*</TextDefault>
          <Select {...register("how_did_you_meet_us")}>
            <option value="">-- Selecione --</option>
            <option value="Google">Google</option>
            <option value="Cursos">Cursos</option>
            <option value="Instagram">Instagram</option>
            <option value="Linkedin">Linkedin</option>
            <option value="Indicação">Indicação</option>
            <option value="Outros">Outros</option>
          </Select>
          {errors.how_did_you_meet_us?.message && (
            <p className="error-validation">Campo obrigatório</p>
          )}
          <WrapperRadio>
            <InputCheckbox
              type="checkbox"
              checked={checkedLGPD}
              onChange={e => setCheckedLGPD(e.target.checked)}
            />
            <Label>
              Estou de acordo com os{" "}
              <u>
                <i
                  style={{ cursor: "pointer", marginRight: "3px" }}
                  onClick={() =>
                    window.open("https://uxdoc.com.br/termos-de-uso/")
                  }
                >
                  termos de uso
                </i>
              </u>
              e a{`\n`}
              <u>
                {`\n`}
                <i
                  onClick={() =>
                    window.open("https://uxdoc.com.br/politica-de-privacidade")
                  }
                  style={{ cursor: "pointer", marginRight: "1px" }}
                >
                  {" "}
                  política de privacidade
                </i>
              </u>{" "}
              do UX DOC.
            </Label>
          </WrapperRadio>
          <ButtonCreateNewAccount type="submit">
            {loading ? (
              <LoadingFlex>
                <PuffLoader color="#ffff" size="28" />
              </LoadingFlex>
            ) : (
              `Cadastrar`
            )}
          </ButtonCreateNewAccount>

          <SpaceFinal />
          <ButtonLoginMobile onClick={() => navigate("/")}>
            {" "}
            Já tem conta? Faça o login
          </ButtonLoginMobile>
        </CreateAccountContent>
      </RightWrapper>
    </Container>
  );
};

export default RegisterScreen;
